import { FormattedMessage } from 'react-intl';
import { Locale } from '@synergy/models';
import { Paper, TableCell, TableRow } from '@mui/material';
import { PoolTypography, PoolVirtualTable } from '@synergy/components-next';
import { getLocalizedString } from '@synergy/utils';

import { DemandContactTopicRegionCount } from '../../../../models/demand-contact-topic-region-count';

type Props = {
    locales: Locale[];
    data: DemandContactTopicRegionCount[];
};

export function ContactCountPerTopicAndRegionTable({ data, locales }: Props) {
    return (
        <Paper elevation={0} sx={{ height: '500px', width: '100%' }}>
            <PoolVirtualTable
                data={data}
                fixedHeaderContent={() => (
                    <TableRow sx={{ background: theme => theme.palette.grey[200] }}>
                        <TableCell>
                            <FormattedMessage id="app.demands.detail.topics.topics" />
                        </TableCell>
                        <TableCell>
                            <FormattedMessage id="app.label.region" />
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                            <FormattedMessage id="app.demands.detail.topics.contactCountTable.contactCount" />
                        </TableCell>
                    </TableRow>
                )}
                rowRenderer={item => (
                    <>
                        <TableCell>
                            <PoolTypography typography="body1">
                                {getLocalizedString(locales, item.topicTitle)}
                            </PoolTypography>
                        </TableCell>
                        <TableCell>
                            <PoolTypography typography="body1">{item.regionName}</PoolTypography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                            <PoolTypography typography="body1">{item.count}</PoolTypography>
                        </TableCell>
                    </>
                )}
            />
        </Paper>
    );
}
